import { Button, Grid, Stack } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { systemTabsForRole } from "../navigation";
import { useTranslation } from "react-i18next";

const SystemAdvancedPage = ({ children, role }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const tools = [
    { label: "Detecciones", to: "/system/advanced", match: (path) => path === "/system/advanced" },
    { label: "Camaras", to: "/system/advanced/cameras", match: (path) => path.startsWith("/system/advanced/cameras") },
    { label: "Config visual IA", to: "/system/advanced/ai-visual", match: (path) => path.startsWith("/system/advanced/ai-visual") },
  ];

  return (
    <ModuleLayout title={t("platform.pages.advanced.title")} subtitle={t("platform.pages.advanced.subtitle")} breadcrumbs={[t("platform.nav.system"), t("platform.tabs.advanced")]} tabs={systemTabsForRole(role)} dataMode={{ mode: "real" }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <Stack direction="row" gap={1} flexWrap="wrap">
            {tools.map((tool) => (
              <Button
                key={tool.to}
                component={RouterLink}
                to={tool.to}
                variant={tool.match(location.pathname) ? "contained" : "outlined"}
              >
                {tool.label}
              </Button>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12}>{children}</Grid>
      </Grid>
    </ModuleLayout>
  );
};

export default SystemAdvancedPage;
